// Port of api/fuel/app/classes/controller/api/monty/games/suggest.php
import { buildSuggestResponse } from 'offline/api/games/shared'

export default function(params) {
	return buildSuggestResponse(params)
}
